<template>
  <PlayerTournamentsList is-my />
</template>

<script>
import PlayerTournamentsList from './index.vue';
export default {
  name: 'My',
  components: { PlayerTournamentsList },
};
</script>
